webpackJsonp([1],{

/***/ "044T":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "07I5":
/***/ (function(module, exports) {

module.exports = [{"id":0,"url":"/static/photos/couples/1.jpg","thumbUrl":"/static/thumbs/couples/1.jpg","style":{"background-image":"url(\"/static/photos/couples/1.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/couples/1.jpg\")"}},{"id":1,"url":"/static/photos/couples/166A2058.jpg","thumbUrl":"/static/thumbs/couples/166A2058.jpg","style":{"background-image":"url(\"/static/photos/couples/166A2058.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/couples/166A2058.jpg\")"}},{"id":2,"url":"/static/photos/couples/166A2096.jpg","thumbUrl":"/static/thumbs/couples/166A2096.jpg","style":{"background-image":"url(\"/static/photos/couples/166A2096.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/couples/166A2096.jpg\")"}},{"id":3,"url":"/static/photos/couples/3.jpg","thumbUrl":"/static/thumbs/couples/3.jpg","style":{"background-image":"url(\"/static/photos/couples/3.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/couples/3.jpg\")"}},{"id":4,"url":"/static/photos/couples/5.jpg","thumbUrl":"/static/thumbs/couples/5.jpg","style":{"background-image":"url(\"/static/photos/couples/5.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/couples/5.jpg\")"}},{"id":5,"url":"/static/photos/couples/IMG_0127.jpg","thumbUrl":"/static/thumbs/couples/IMG_0127.jpg","style":{"background-image":"url(\"/static/photos/couples/IMG_0127.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/couples/IMG_0127.jpg\")"}},{"id":6,"url":"/static/photos/couples/IMG_0754.jpg","thumbUrl":"/static/thumbs/couples/IMG_0754.jpg","style":{"background-image":"url(\"/static/photos/couples/IMG_0754.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/couples/IMG_0754.jpg\")"}},{"id":7,"url":"/static/photos/couples/IMG_2540.jpg","thumbUrl":"/static/thumbs/couples/IMG_2540.jpg","style":{"background-image":"url(\"/static/photos/couples/IMG_2540.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/couples/IMG_2540.jpg\")"}},{"id":8,"url":"/static/photos/couples/IMG_2662.jpg","thumbUrl":"/static/thumbs/couples/IMG_2662.jpg","style":{"background-image":"url(\"/static/photos/couples/IMG_2662.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/couples/IMG_2662.jpg\")"}},{"id":9,"url":"/static/photos/couples/IMG_2793.jpg","thumbUrl":"/static/thumbs/couples/IMG_2793.jpg","style":{"background-image":"url(\"/static/photos/couples/IMG_2793.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/couples/IMG_2793.jpg\")"}},{"id":10,"url":"/static/photos/couples/IMG_2900.jpg","thumbUrl":"/static/thumbs/couples/IMG_2900.jpg","style":{"background-image":"url(\"/static/photos/couples/IMG_2900.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/couples/IMG_2900.jpg\")"}},{"id":11,"url":"/static/photos/couples/IMG_4471.jpg","thumbUrl":"/static/thumbs/couples/IMG_4471.jpg","style":{"background-image":"url(\"/static/photos/couples/IMG_4471.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/couples/IMG_4471.jpg\")"}},{"id":12,"url":"/static/photos/couples/IMG_4512.jpg","thumbUrl":"/static/thumbs/couples/IMG_4512.jpg","style":{"background-image":"url(\"/static/photos/couples/IMG_4512.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/couples/IMG_4512.jpg\")"}},{"id":13,"url":"/static/photos/couples/IMG_9049.jpg","thumbUrl":"/static/thumbs/couples/IMG_9049.jpg","style":{"background-image":"url(\"/static/photos/couples/IMG_9049.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/couples/IMG_9049.jpg\")"}}]

/***/ }),

/***/ "3GKq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"about"},[_c('h2',[_vm._v("About Me")]),_vm._v(" "),_c('b-row',{attrs:{"align-v":"center"}},[_c('b-col',[_c('img',{attrs:{"src":"/static/photos/alyson.jpg"}})]),_vm._v(" "),_c('b-col',{},[_c('p',[_vm._v("\n        I am a natural-light freelance photographer located in the Colorado Springs, Colorado area.\n      ")])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7ARk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7y6u":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9M+g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "B3Kk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Slideshow_vue__ = __webpack_require__("uFRC");
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'portfolio',
  data: function data() {
    return {
      title: '',
      selected: -1,
      showSlides: false,
      items: []
    };
  },
  created: function created() {
    this.init(this.$route.params.selection);
  },

  watch: {
    '$route.params.selection': function $routeParamsSelection(selection) {
      this.init(selection);
    },
    'selected': function selected(idx) {
      if (idx > -1) {
        document.body.className = 'slideshow';
      } else {
        document.body.className = '';
      }
    }
  },
  components: {
    slideshow: __WEBPACK_IMPORTED_MODULE_0__Slideshow_vue__["a" /* default */]
  },
  methods: {
    init: function init(selection) {
      var _this = this;

      this.title = selection;
      __webpack_require__("RpDi")("./" + selection + '.json').then(function (items) {
        _this.items = items;
      });
    },
    select: function select(idx) {
      this.selected = idx;
    }
  }
});

/***/ }),

/***/ "D4uH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Icon_vue__ = __webpack_require__("dXrS");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_3fe67fee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Icon_vue__ = __webpack_require__("dqBQ");
function injectStyle (ssrContext) {
  __webpack_require__("7ARk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Icon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_3fe67fee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Icon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IRfe":
/***/ (function(module, exports) {

module.exports = [{"id":0,"url":"/static/photos/portraits/018.jpg","thumbUrl":"/static/thumbs/portraits/018.jpg","style":{"background-image":"url(\"/static/photos/portraits/018.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/portraits/018.jpg\")"}},{"id":1,"url":"/static/photos/portraits/C.jpg","thumbUrl":"/static/thumbs/portraits/C.jpg","style":{"background-image":"url(\"/static/photos/portraits/C.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/portraits/C.jpg\")"}},{"id":2,"url":"/static/photos/portraits/F.jpg","thumbUrl":"/static/thumbs/portraits/F.jpg","style":{"background-image":"url(\"/static/photos/portraits/F.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/portraits/F.jpg\")"}},{"id":3,"url":"/static/photos/portraits/G.jpg","thumbUrl":"/static/thumbs/portraits/G.jpg","style":{"background-image":"url(\"/static/photos/portraits/G.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/portraits/G.jpg\")"}},{"id":4,"url":"/static/photos/portraits/IMG_0393.jpg","thumbUrl":"/static/thumbs/portraits/IMG_0393.jpg","style":{"background-image":"url(\"/static/photos/portraits/IMG_0393.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/portraits/IMG_0393.jpg\")"}},{"id":5,"url":"/static/photos/portraits/IMG_0656.jpg","thumbUrl":"/static/thumbs/portraits/IMG_0656.jpg","style":{"background-image":"url(\"/static/photos/portraits/IMG_0656.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/portraits/IMG_0656.jpg\")"}},{"id":6,"url":"/static/photos/portraits/IMG_1075.jpg","thumbUrl":"/static/thumbs/portraits/IMG_1075.jpg","style":{"background-image":"url(\"/static/photos/portraits/IMG_1075.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/portraits/IMG_1075.jpg\")"}},{"id":7,"url":"/static/photos/portraits/IMG_1150.jpg","thumbUrl":"/static/thumbs/portraits/IMG_1150.jpg","style":{"background-image":"url(\"/static/photos/portraits/IMG_1150.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/portraits/IMG_1150.jpg\")"}},{"id":8,"url":"/static/photos/portraits/IMG_1180.jpg","thumbUrl":"/static/thumbs/portraits/IMG_1180.jpg","style":{"background-image":"url(\"/static/photos/portraits/IMG_1180.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/portraits/IMG_1180.jpg\")"}},{"id":9,"url":"/static/photos/portraits/IMG_1193.jpg","thumbUrl":"/static/thumbs/portraits/IMG_1193.jpg","style":{"background-image":"url(\"/static/photos/portraits/IMG_1193.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/portraits/IMG_1193.jpg\")"}},{"id":10,"url":"/static/photos/portraits/IMG_1198.jpg","thumbUrl":"/static/thumbs/portraits/IMG_1198.jpg","style":{"background-image":"url(\"/static/photos/portraits/IMG_1198.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/portraits/IMG_1198.jpg\")"}},{"id":11,"url":"/static/photos/portraits/IMG_1674.jpg","thumbUrl":"/static/thumbs/portraits/IMG_1674.jpg","style":{"background-image":"url(\"/static/photos/portraits/IMG_1674.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/portraits/IMG_1674.jpg\")"}},{"id":12,"url":"/static/photos/portraits/IMG_1678.jpg","thumbUrl":"/static/thumbs/portraits/IMG_1678.jpg","style":{"background-image":"url(\"/static/photos/portraits/IMG_1678.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/portraits/IMG_1678.jpg\")"}},{"id":13,"url":"/static/photos/portraits/IMG_1718.jpg","thumbUrl":"/static/thumbs/portraits/IMG_1718.jpg","style":{"background-image":"url(\"/static/photos/portraits/IMG_1718.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/portraits/IMG_1718.jpg\")"}},{"id":14,"url":"/static/photos/portraits/IMG_2119.jpg","thumbUrl":"/static/thumbs/portraits/IMG_2119.jpg","style":{"background-image":"url(\"/static/photos/portraits/IMG_2119.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/portraits/IMG_2119.jpg\")"}},{"id":15,"url":"/static/photos/portraits/IMG_2168.jpg","thumbUrl":"/static/thumbs/portraits/IMG_2168.jpg","style":{"background-image":"url(\"/static/photos/portraits/IMG_2168.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/portraits/IMG_2168.jpg\")"}},{"id":16,"url":"/static/photos/portraits/IMG_2195.jpg","thumbUrl":"/static/thumbs/portraits/IMG_2195.jpg","style":{"background-image":"url(\"/static/photos/portraits/IMG_2195.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/portraits/IMG_2195.jpg\")"}},{"id":17,"url":"/static/photos/portraits/IMG_2212.jpg","thumbUrl":"/static/thumbs/portraits/IMG_2212.jpg","style":{"background-image":"url(\"/static/photos/portraits/IMG_2212.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/portraits/IMG_2212.jpg\")"}},{"id":18,"url":"/static/photos/portraits/IMG_2230.jpg","thumbUrl":"/static/thumbs/portraits/IMG_2230.jpg","style":{"background-image":"url(\"/static/photos/portraits/IMG_2230.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/portraits/IMG_2230.jpg\")"}},{"id":19,"url":"/static/photos/portraits/IMG_2243.jpg","thumbUrl":"/static/thumbs/portraits/IMG_2243.jpg","style":{"background-image":"url(\"/static/photos/portraits/IMG_2243.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/portraits/IMG_2243.jpg\")"}},{"id":20,"url":"/static/photos/portraits/IMG_2482bw.jpg","thumbUrl":"/static/thumbs/portraits/IMG_2482bw.jpg","style":{"background-image":"url(\"/static/photos/portraits/IMG_2482bw.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/portraits/IMG_2482bw.jpg\")"}},{"id":21,"url":"/static/photos/portraits/IMG_2497.jpg","thumbUrl":"/static/thumbs/portraits/IMG_2497.jpg","style":{"background-image":"url(\"/static/photos/portraits/IMG_2497.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/portraits/IMG_2497.jpg\")"}},{"id":22,"url":"/static/photos/portraits/IMG_2735.jpg","thumbUrl":"/static/thumbs/portraits/IMG_2735.jpg","style":{"background-image":"url(\"/static/photos/portraits/IMG_2735.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/portraits/IMG_2735.jpg\")"}},{"id":23,"url":"/static/photos/portraits/IMG_3466.jpg","thumbUrl":"/static/thumbs/portraits/IMG_3466.jpg","style":{"background-image":"url(\"/static/photos/portraits/IMG_3466.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/portraits/IMG_3466.jpg\")"}},{"id":24,"url":"/static/photos/portraits/IMG_3687bw.jpg","thumbUrl":"/static/thumbs/portraits/IMG_3687bw.jpg","style":{"background-image":"url(\"/static/photos/portraits/IMG_3687bw.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/portraits/IMG_3687bw.jpg\")"}},{"id":25,"url":"/static/photos/portraits/IMG_4167.jpg","thumbUrl":"/static/thumbs/portraits/IMG_4167.jpg","style":{"background-image":"url(\"/static/photos/portraits/IMG_4167.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/portraits/IMG_4167.jpg\")"}},{"id":26,"url":"/static/photos/portraits/IMG_4208.jpg","thumbUrl":"/static/thumbs/portraits/IMG_4208.jpg","style":{"background-image":"url(\"/static/photos/portraits/IMG_4208.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/portraits/IMG_4208.jpg\")"}},{"id":27,"url":"/static/photos/portraits/IMG_4213.jpg","thumbUrl":"/static/thumbs/portraits/IMG_4213.jpg","style":{"background-image":"url(\"/static/photos/portraits/IMG_4213.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/portraits/IMG_4213.jpg\")"}},{"id":28,"url":"/static/photos/portraits/IMG_4413.jpg","thumbUrl":"/static/thumbs/portraits/IMG_4413.jpg","style":{"background-image":"url(\"/static/photos/portraits/IMG_4413.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/portraits/IMG_4413.jpg\")"}},{"id":29,"url":"/static/photos/portraits/IMG_6927.jpg","thumbUrl":"/static/thumbs/portraits/IMG_6927.jpg","style":{"background-image":"url(\"/static/photos/portraits/IMG_6927.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/portraits/IMG_6927.jpg\")"}},{"id":30,"url":"/static/photos/portraits/IMG_6946.jpg","thumbUrl":"/static/thumbs/portraits/IMG_6946.jpg","style":{"background-image":"url(\"/static/photos/portraits/IMG_6946.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/portraits/IMG_6946.jpg\")"}},{"id":31,"url":"/static/photos/portraits/IMG_6998.jpg","thumbUrl":"/static/thumbs/portraits/IMG_6998.jpg","style":{"background-image":"url(\"/static/photos/portraits/IMG_6998.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/portraits/IMG_6998.jpg\")"}},{"id":32,"url":"/static/photos/portraits/K.jpg","thumbUrl":"/static/thumbs/portraits/K.jpg","style":{"background-image":"url(\"/static/photos/portraits/K.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/portraits/K.jpg\")"}},{"id":33,"url":"/static/photos/portraits/L.jpg","thumbUrl":"/static/thumbs/portraits/L.jpg","style":{"background-image":"url(\"/static/photos/portraits/L.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/portraits/L.jpg\")"}},{"id":34,"url":"/static/photos/portraits/Q (2).jpg","thumbUrl":"/static/thumbs/portraits/Q (2).jpg","style":{"background-image":"url(\"/static/photos/portraits/Q (2).jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/portraits/Q (2).jpg\")"}},{"id":35,"url":"/static/photos/portraits/Q.jpg","thumbUrl":"/static/thumbs/portraits/Q.jpg","style":{"background-image":"url(\"/static/photos/portraits/Q.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/portraits/Q.jpg\")"}},{"id":36,"url":"/static/photos/portraits/W.jpg","thumbUrl":"/static/thumbs/portraits/W.jpg","style":{"background-image":"url(\"/static/photos/portraits/W.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/portraits/W.jpg\")"}}]

/***/ }),

/***/ "KI/a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'pricing',
  data: function data() {
    return {
      priceList: [
      // {
      //   id: 'portrait',
      //   title: 'Portrait/Senior',
      //   price: '$200',
      //   href: 'mailto:photographer@alysonsivek.com?subject=Portrait%20Session',
      //   features: [
      //     '1.5 - 2 hour session',
      //     'Up to two outfit changes',
      //     '25 - 30 high resolution images in an online gallery with copyright release'
      //   ]
      // },
      {
        id: 'couple',
        title: 'Couple',
        price: '$250',
        href: 'mailto:photographer@alysonsivek.com?subject=Engagement%20Session',
        features: ['1.5 - 2 hour session', 'Up to two outfit changes', '25 - 30 high resolution images in an online gallery with copyright release']
      }, {
        id: 'family',
        title: 'Family',
        price: '$270',
        href: 'mailto:photographer@alysonsivek.com?subject=Family%20Session',
        features: ['1.5 - 2 hour session', 'Up to two outfit changes', '40 - 45 high resolution images in an online gallery with copyright release']
      }, {
        id: 'wedding',
        title: 'Wedding',
        mini: 'starting at',
        price: '$1500',
        href: 'mailto:photographer@alysonsivek.com?subject=Wedding',
        forceBottom: true,
        features: ['Book with an engagement (couple) session for a discount!']
      }]
    };
  }
});

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8bdc6df8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("fkRi");
function injectStyle (ssrContext) {
  __webpack_require__("Vr2z")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8bdc6df8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Mkwv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pricing_vue__ = __webpack_require__("KI/a");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49a2ae88_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pricing_vue__ = __webpack_require__("uxbW");
function injectStyle (ssrContext) {
  __webpack_require__("7y6u")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-49a2ae88"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pricing_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49a2ae88_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pricing_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__ = __webpack_require__("Tqaz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_dist_css_bootstrap_min_css__ = __webpack_require__("qb6w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_dist_css_bootstrap_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_bootstrap_dist_css_bootstrap_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__("9M+g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_awesome_icons__ = __webpack_require__("D/PP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_in_viewport_directive__ = __webpack_require__("VYcz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_in_viewport_directive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_in_viewport_directive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_awesome_components_Icon_vue__ = __webpack_require__("D4uH");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.











__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('icon', __WEBPACK_IMPORTED_MODULE_8_vue_awesome_components_Icon_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].directive('in-viewport', __WEBPACK_IMPORTED_MODULE_7_vue_in_viewport_directive___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */] }
});

/***/ }),

/***/ "Nc4y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Q0le":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slideshow noselect",class:{active: _vm.isActive},on:{"click":function($event){_vm.activate()}}},[_c('div',{staticClass:"navigate prev",on:{"click":function($event){$event.stopPropagation();_vm.prev()}}},[_c('icon',{attrs:{"name":"chevron-left","scale":"2"}})],1),_vm._v(" "),_c('div',{staticClass:"viewer",style:(_vm.items[_vm.idx].style)}),_vm._v(" "),_c('div',{staticClass:"navigate next",on:{"click":function($event){$event.stopPropagation();_vm.next()}}},[_c('icon',{attrs:{"name":"chevron-right","scale":"2"}})],1),_vm._v(" "),_c('div',{staticClass:"close",on:{"click":function($event){_vm.close()}}},[_vm._v("\n    ×\n  ")]),_vm._v(" "),_c('div',{staticClass:"preloader"},_vm._l((_vm.preload),function(item){return _c('img',{attrs:{"src":item.url}})}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QRyc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-container',{staticClass:"portfolio"},[_c('h2',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('b-row',{attrs:{"align-v":"center"}},_vm._l((_vm.items),function(item,idx){return _c('b-col',{key:item.id,staticClass:"photo-col",attrs:{"cols":"4"}},[_c('div',{staticClass:"photo-block",style:(item.thumbStyle),on:{"click":function($event){_vm.select(idx)}}},[_c('div')])])}))],1),_vm._v(" "),(_vm.selected > -1)?_c('slideshow',{attrs:{"items":_vm.items,"selected":_vm.selected},on:{"close":function($event){_vm.selected = -1}}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ROzN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"main-container"},_vm._l((_vm.rows),function(row,idx){return _c('b-row',{key:idx},_vm._l((row),function(item){return _c('b-col',{key:item.id,staticClass:"photo-block-main"},[_c('div',{staticClass:"photo-block",style:(item.thumbStyle)},[_c('div')])])}))}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RpDi":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./couples.json": "07I5",
	"./families.json": "YErK",
	"./main.json": "wTbr",
	"./portraits.json": "IRfe",
	"./weddings.json": "b0xR"
};
function webpackAsyncContext(req) {
	return webpackAsyncContextResolve(req).then(__webpack_require__);
};
function webpackAsyncContextResolve(req) {
	return new Promise(function(resolve, reject) {
		var id = map[req];
		if(!(id + 1)) // check for number or string
			reject(new Error("Cannot find module '" + req + "'."));
		else
			resolve(id);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.resolve = webpackAsyncContextResolve;
module.exports = webpackAsyncContext;
webpackAsyncContext.id = "RpDi";

/***/ }),

/***/ "Uhku":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_main_json__ = __webpack_require__("wTbr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_main_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_main_json__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'mainPhotos',
  data: function data() {
    return {
      rows: [__WEBPACK_IMPORTED_MODULE_0__assets_main_json___default.a.slice(0, 3), __WEBPACK_IMPORTED_MODULE_0__assets_main_json___default.a.slice(3, 6), __WEBPACK_IMPORTED_MODULE_0__assets_main_json___default.a.slice(6, 9)]
    };
  }
});

/***/ }),

/***/ "Vr2z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YErK":
/***/ (function(module, exports) {

module.exports = [{"id":0,"url":"/static/photos/families/166A1047.jpg","thumbUrl":"/static/thumbs/families/166A1047.jpg","style":{"background-image":"url(\"/static/photos/families/166A1047.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/families/166A1047.jpg\")"}},{"id":1,"url":"/static/photos/families/166A1280.jpg","thumbUrl":"/static/thumbs/families/166A1280.jpg","style":{"background-image":"url(\"/static/photos/families/166A1280.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/families/166A1280.jpg\")"}},{"id":2,"url":"/static/photos/families/166A1555.jpg","thumbUrl":"/static/thumbs/families/166A1555.jpg","style":{"background-image":"url(\"/static/photos/families/166A1555.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/families/166A1555.jpg\")"}},{"id":3,"url":"/static/photos/families/166A1671.jpg","thumbUrl":"/static/thumbs/families/166A1671.jpg","style":{"background-image":"url(\"/static/photos/families/166A1671.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/families/166A1671.jpg\")"}},{"id":4,"url":"/static/photos/families/166A1940.jpg","thumbUrl":"/static/thumbs/families/166A1940.jpg","style":{"background-image":"url(\"/static/photos/families/166A1940.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/families/166A1940.jpg\")"}},{"id":5,"url":"/static/photos/families/166A2001.jpg","thumbUrl":"/static/thumbs/families/166A2001.jpg","style":{"background-image":"url(\"/static/photos/families/166A2001.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/families/166A2001.jpg\")"}},{"id":6,"url":"/static/photos/families/166A2009.jpg","thumbUrl":"/static/thumbs/families/166A2009.jpg","style":{"background-image":"url(\"/static/photos/families/166A2009.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/families/166A2009.jpg\")"}},{"id":7,"url":"/static/photos/families/166A2033.jpg","thumbUrl":"/static/thumbs/families/166A2033.jpg","style":{"background-image":"url(\"/static/photos/families/166A2033.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/families/166A2033.jpg\")"}},{"id":8,"url":"/static/photos/families/166A6167.jpg","thumbUrl":"/static/thumbs/families/166A6167.jpg","style":{"background-image":"url(\"/static/photos/families/166A6167.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/families/166A6167.jpg\")"}},{"id":9,"url":"/static/photos/families/166A9011.jpg","thumbUrl":"/static/thumbs/families/166A9011.jpg","style":{"background-image":"url(\"/static/photos/families/166A9011.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/families/166A9011.jpg\")"}},{"id":10,"url":"/static/photos/families/166A9027.jpg","thumbUrl":"/static/thumbs/families/166A9027.jpg","style":{"background-image":"url(\"/static/photos/families/166A9027.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/families/166A9027.jpg\")"}},{"id":11,"url":"/static/photos/families/166A9110.jpg","thumbUrl":"/static/thumbs/families/166A9110.jpg","style":{"background-image":"url(\"/static/photos/families/166A9110.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/families/166A9110.jpg\")"}},{"id":12,"url":"/static/photos/families/166A9205.jpg","thumbUrl":"/static/thumbs/families/166A9205.jpg","style":{"background-image":"url(\"/static/photos/families/166A9205.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/families/166A9205.jpg\")"}},{"id":13,"url":"/static/photos/families/166A9319.jpg","thumbUrl":"/static/thumbs/families/166A9319.jpg","style":{"background-image":"url(\"/static/photos/families/166A9319.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/families/166A9319.jpg\")"}},{"id":14,"url":"/static/photos/families/166A9575.jpg","thumbUrl":"/static/thumbs/families/166A9575.jpg","style":{"background-image":"url(\"/static/photos/families/166A9575.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/families/166A9575.jpg\")"}},{"id":15,"url":"/static/photos/families/166A9871.jpg","thumbUrl":"/static/thumbs/families/166A9871.jpg","style":{"background-image":"url(\"/static/photos/families/166A9871.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/families/166A9871.jpg\")"}},{"id":16,"url":"/static/photos/families/IMG_0049 (1).jpg","thumbUrl":"/static/thumbs/families/IMG_0049 (1).jpg","style":{"background-image":"url(\"/static/photos/families/IMG_0049 (1).jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/families/IMG_0049 (1).jpg\")"}},{"id":17,"url":"/static/photos/families/IMG_0056 (1).jpg","thumbUrl":"/static/thumbs/families/IMG_0056 (1).jpg","style":{"background-image":"url(\"/static/photos/families/IMG_0056 (1).jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/families/IMG_0056 (1).jpg\")"}},{"id":18,"url":"/static/photos/families/IMG_1603.jpg","thumbUrl":"/static/thumbs/families/IMG_1603.jpg","style":{"background-image":"url(\"/static/photos/families/IMG_1603.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/families/IMG_1603.jpg\")"}},{"id":19,"url":"/static/photos/families/IMG_2481.jpg","thumbUrl":"/static/thumbs/families/IMG_2481.jpg","style":{"background-image":"url(\"/static/photos/families/IMG_2481.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/families/IMG_2481.jpg\")"}},{"id":20,"url":"/static/photos/families/IMG_4337.jpg","thumbUrl":"/static/thumbs/families/IMG_4337.jpg","style":{"background-image":"url(\"/static/photos/families/IMG_4337.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/families/IMG_4337.jpg\")"}},{"id":21,"url":"/static/photos/families/IMG_4887.jpg","thumbUrl":"/static/thumbs/families/IMG_4887.jpg","style":{"background-image":"url(\"/static/photos/families/IMG_4887.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/families/IMG_4887.jpg\")"}},{"id":22,"url":"/static/photos/families/IMG_5059.jpg","thumbUrl":"/static/thumbs/families/IMG_5059.jpg","style":{"background-image":"url(\"/static/photos/families/IMG_5059.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/families/IMG_5059.jpg\")"}},{"id":23,"url":"/static/photos/families/IMG_5898.jpg","thumbUrl":"/static/thumbs/families/IMG_5898.jpg","style":{"background-image":"url(\"/static/photos/families/IMG_5898.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/families/IMG_5898.jpg\")"}},{"id":24,"url":"/static/photos/families/IMG_6329.jpg","thumbUrl":"/static/thumbs/families/IMG_6329.jpg","style":{"background-image":"url(\"/static/photos/families/IMG_6329.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/families/IMG_6329.jpg\")"}},{"id":25,"url":"/static/photos/families/IMG_7174.jpg","thumbUrl":"/static/thumbs/families/IMG_7174.jpg","style":{"background-image":"url(\"/static/photos/families/IMG_7174.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/families/IMG_7174.jpg\")"}},{"id":26,"url":"/static/photos/families/IMG_7349.jpg","thumbUrl":"/static/thumbs/families/IMG_7349.jpg","style":{"background-image":"url(\"/static/photos/families/IMG_7349.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/families/IMG_7349.jpg\")"}},{"id":27,"url":"/static/photos/families/IMG_7566.jpg","thumbUrl":"/static/thumbs/families/IMG_7566.jpg","style":{"background-image":"url(\"/static/photos/families/IMG_7566.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/families/IMG_7566.jpg\")"}},{"id":28,"url":"/static/photos/families/IMG_7642.jpg","thumbUrl":"/static/thumbs/families/IMG_7642.jpg","style":{"background-image":"url(\"/static/photos/families/IMG_7642.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/families/IMG_7642.jpg\")"}},{"id":29,"url":"/static/photos/families/IMG_8481.jpg","thumbUrl":"/static/thumbs/families/IMG_8481.jpg","style":{"background-image":"url(\"/static/photos/families/IMG_8481.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/families/IMG_8481.jpg\")"}},{"id":30,"url":"/static/photos/families/IMG_8534.jpg","thumbUrl":"/static/thumbs/families/IMG_8534.jpg","style":{"background-image":"url(\"/static/photos/families/IMG_8534.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/families/IMG_8534.jpg\")"}},{"id":31,"url":"/static/photos/families/IMG_8842.jpg","thumbUrl":"/static/thumbs/families/IMG_8842.jpg","style":{"background-image":"url(\"/static/photos/families/IMG_8842.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/families/IMG_8842.jpg\")"}},{"id":32,"url":"/static/photos/families/IMG_9137.jpg","thumbUrl":"/static/thumbs/families/IMG_9137.jpg","style":{"background-image":"url(\"/static/photos/families/IMG_9137.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/families/IMG_9137.jpg\")"}},{"id":33,"url":"/static/photos/families/IMG_9271.jpg","thumbUrl":"/static/thumbs/families/IMG_9271.jpg","style":{"background-image":"url(\"/static/photos/families/IMG_9271.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/families/IMG_9271.jpg\")"}},{"id":34,"url":"/static/photos/families/IMG_9456.jpg","thumbUrl":"/static/thumbs/families/IMG_9456.jpg","style":{"background-image":"url(\"/static/photos/families/IMG_9456.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/families/IMG_9456.jpg\")"}},{"id":35,"url":"/static/photos/families/IMG_9611-2-2.jpg","thumbUrl":"/static/thumbs/families/IMG_9611-2-2.jpg","style":{"background-image":"url(\"/static/photos/families/IMG_9611-2-2.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/families/IMG_9611-2-2.jpg\")"}},{"id":36,"url":"/static/photos/families/IMG_9690.jpg","thumbUrl":"/static/thumbs/families/IMG_9690.jpg","style":{"background-image":"url(\"/static/photos/families/IMG_9690.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/families/IMG_9690.jpg\")"}}]

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Main__ = __webpack_require__("s6+2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Pricing__ = __webpack_require__("Mkwv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_About__ = __webpack_require__("c27y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Portfolio__ = __webpack_require__("yRJc");







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  // mode: 'history',
  routes: [{
    path: '/',
    name: 'Main',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Main__["a" /* default */]
  }, {
    path: '/investment',
    name: 'Pricing',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Pricing__["a" /* default */]
  }, {
    path: '/about',
    name: 'About',
    component: __WEBPACK_IMPORTED_MODULE_4__components_About__["a" /* default */]
  }, {
    path: '/portfolio/:selection',
    name: 'Portfolio',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Portfolio__["a" /* default */]
  }]
}));

/***/ }),

/***/ "Zs8U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'about'
});

/***/ }),

/***/ "act2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'slideshow',
  props: ['items', 'selected'],
  data: function data() {
    return {
      isActive: false,
      idx: this.selected,
      preload: []
    };
  },
  created: function created() {
    this.preloadNext(2, 1);
    this.preloadNext(2, -1);
  },

  methods: {
    close: function close() {
      this.$emit('close');
    },
    activate: function activate() {
      this.isActive = true;
      var _this = this;
      setTimeout(function () {
        _this.isActive = false;
      }, 2000);
    },
    preloadNext: function preloadNext(num, dir) {
      var idx = this.idx;
      var i;

      if (dir < 0) {
        for (i = 0; i < num; i++) {
          if (--idx < 0) idx = this.items.length - 1;
          if (this.preload.indexOf(this.items[idx]) < 0) this.preload.push(this.items[idx]);
        }
      } else {
        for (i = 0; i < num; i++) {
          if (++idx >= this.items.length) idx = 0;
          if (this.preload.indexOf(this.items[idx]) < 0) this.preload.push(this.items[idx]);
        }
      }
    },
    prev: function prev() {
      this.idx--;
      if (this.idx < 0) this.idx = this.items.length - 1;
      this.preloadNext(2, -1);
    },
    next: function next() {
      this.idx++;
      if (this.idx >= this.items.length) this.idx = 0;
      this.preloadNext(2, 1);
    }
  }
});

/***/ }),

/***/ "b0xR":
/***/ (function(module, exports) {

module.exports = [{"id":0,"url":"/static/photos/weddings/166A0260.jpg","thumbUrl":"/static/thumbs/weddings/166A0260.jpg","style":{"background-image":"url(\"/static/photos/weddings/166A0260.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/weddings/166A0260.jpg\")"}},{"id":1,"url":"/static/photos/weddings/166A0605.jpg","thumbUrl":"/static/thumbs/weddings/166A0605.jpg","style":{"background-image":"url(\"/static/photos/weddings/166A0605.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/weddings/166A0605.jpg\")"}},{"id":2,"url":"/static/photos/weddings/166A1302.jpg","thumbUrl":"/static/thumbs/weddings/166A1302.jpg","style":{"background-image":"url(\"/static/photos/weddings/166A1302.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/weddings/166A1302.jpg\")"}},{"id":3,"url":"/static/photos/weddings/166A1537.jpg","thumbUrl":"/static/thumbs/weddings/166A1537.jpg","style":{"background-image":"url(\"/static/photos/weddings/166A1537.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/weddings/166A1537.jpg\")"}},{"id":4,"url":"/static/photos/weddings/166A9439.jpg","thumbUrl":"/static/thumbs/weddings/166A9439.jpg","style":{"background-image":"url(\"/static/photos/weddings/166A9439.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/weddings/166A9439.jpg\")"}},{"id":5,"url":"/static/photos/weddings/166A9476.jpg","thumbUrl":"/static/thumbs/weddings/166A9476.jpg","style":{"background-image":"url(\"/static/photos/weddings/166A9476.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/weddings/166A9476.jpg\")"}},{"id":6,"url":"/static/photos/weddings/166A9876.jpg","thumbUrl":"/static/thumbs/weddings/166A9876.jpg","style":{"background-image":"url(\"/static/photos/weddings/166A9876.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/weddings/166A9876.jpg\")"}},{"id":7,"url":"/static/photos/weddings/IMG_0052.jpg","thumbUrl":"/static/thumbs/weddings/IMG_0052.jpg","style":{"background-image":"url(\"/static/photos/weddings/IMG_0052.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/weddings/IMG_0052.jpg\")"}},{"id":8,"url":"/static/photos/weddings/IMG_1313.jpg","thumbUrl":"/static/thumbs/weddings/IMG_1313.jpg","style":{"background-image":"url(\"/static/photos/weddings/IMG_1313.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/weddings/IMG_1313.jpg\")"}},{"id":9,"url":"/static/photos/weddings/IMG_1378.jpg","thumbUrl":"/static/thumbs/weddings/IMG_1378.jpg","style":{"background-image":"url(\"/static/photos/weddings/IMG_1378.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/weddings/IMG_1378.jpg\")"}},{"id":10,"url":"/static/photos/weddings/IMG_1412.jpg","thumbUrl":"/static/thumbs/weddings/IMG_1412.jpg","style":{"background-image":"url(\"/static/photos/weddings/IMG_1412.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/weddings/IMG_1412.jpg\")"}},{"id":11,"url":"/static/photos/weddings/IMG_1671.jpg","thumbUrl":"/static/thumbs/weddings/IMG_1671.jpg","style":{"background-image":"url(\"/static/photos/weddings/IMG_1671.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/weddings/IMG_1671.jpg\")"}},{"id":12,"url":"/static/photos/weddings/IMG_1899.jpg","thumbUrl":"/static/thumbs/weddings/IMG_1899.jpg","style":{"background-image":"url(\"/static/photos/weddings/IMG_1899.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/weddings/IMG_1899.jpg\")"}},{"id":13,"url":"/static/photos/weddings/IMG_2850.jpg","thumbUrl":"/static/thumbs/weddings/IMG_2850.jpg","style":{"background-image":"url(\"/static/photos/weddings/IMG_2850.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/weddings/IMG_2850.jpg\")"}},{"id":14,"url":"/static/photos/weddings/IMG_3518.jpg","thumbUrl":"/static/thumbs/weddings/IMG_3518.jpg","style":{"background-image":"url(\"/static/photos/weddings/IMG_3518.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/weddings/IMG_3518.jpg\")"}},{"id":15,"url":"/static/photos/weddings/IMG_4683.jpg","thumbUrl":"/static/thumbs/weddings/IMG_4683.jpg","style":{"background-image":"url(\"/static/photos/weddings/IMG_4683.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/weddings/IMG_4683.jpg\")"}},{"id":16,"url":"/static/photos/weddings/IMG_4743.jpg","thumbUrl":"/static/thumbs/weddings/IMG_4743.jpg","style":{"background-image":"url(\"/static/photos/weddings/IMG_4743.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/weddings/IMG_4743.jpg\")"}},{"id":17,"url":"/static/photos/weddings/IMG_4775.jpg","thumbUrl":"/static/thumbs/weddings/IMG_4775.jpg","style":{"background-image":"url(\"/static/photos/weddings/IMG_4775.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/weddings/IMG_4775.jpg\")"}},{"id":18,"url":"/static/photos/weddings/IMG_4833.jpg","thumbUrl":"/static/thumbs/weddings/IMG_4833.jpg","style":{"background-image":"url(\"/static/photos/weddings/IMG_4833.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/weddings/IMG_4833.jpg\")"}},{"id":19,"url":"/static/photos/weddings/IMG_4918.jpg","thumbUrl":"/static/thumbs/weddings/IMG_4918.jpg","style":{"background-image":"url(\"/static/photos/weddings/IMG_4918.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/weddings/IMG_4918.jpg\")"}},{"id":20,"url":"/static/photos/weddings/IMG_5053.jpg","thumbUrl":"/static/thumbs/weddings/IMG_5053.jpg","style":{"background-image":"url(\"/static/photos/weddings/IMG_5053.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/weddings/IMG_5053.jpg\")"}},{"id":21,"url":"/static/photos/weddings/IMG_6288.jpg","thumbUrl":"/static/thumbs/weddings/IMG_6288.jpg","style":{"background-image":"url(\"/static/photos/weddings/IMG_6288.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/weddings/IMG_6288.jpg\")"}},{"id":22,"url":"/static/photos/weddings/IMG_6448.jpg","thumbUrl":"/static/thumbs/weddings/IMG_6448.jpg","style":{"background-image":"url(\"/static/photos/weddings/IMG_6448.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/weddings/IMG_6448.jpg\")"}},{"id":23,"url":"/static/photos/weddings/IMG_6469.jpg","thumbUrl":"/static/thumbs/weddings/IMG_6469.jpg","style":{"background-image":"url(\"/static/photos/weddings/IMG_6469.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/weddings/IMG_6469.jpg\")"}},{"id":24,"url":"/static/photos/weddings/IMG_7031.jpg","thumbUrl":"/static/thumbs/weddings/IMG_7031.jpg","style":{"background-image":"url(\"/static/photos/weddings/IMG_7031.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/weddings/IMG_7031.jpg\")"}},{"id":25,"url":"/static/photos/weddings/IMG_7070.jpg","thumbUrl":"/static/thumbs/weddings/IMG_7070.jpg","style":{"background-image":"url(\"/static/photos/weddings/IMG_7070.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/weddings/IMG_7070.jpg\")"}},{"id":26,"url":"/static/photos/weddings/IMG_8673.jpg","thumbUrl":"/static/thumbs/weddings/IMG_8673.jpg","style":{"background-image":"url(\"/static/photos/weddings/IMG_8673.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/weddings/IMG_8673.jpg\")"}},{"id":27,"url":"/static/photos/weddings/IMG_8887.jpg","thumbUrl":"/static/thumbs/weddings/IMG_8887.jpg","style":{"background-image":"url(\"/static/photos/weddings/IMG_8887.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/weddings/IMG_8887.jpg\")"}},{"id":28,"url":"/static/photos/weddings/IMG_8912.jpg","thumbUrl":"/static/thumbs/weddings/IMG_8912.jpg","style":{"background-image":"url(\"/static/photos/weddings/IMG_8912.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/weddings/IMG_8912.jpg\")"}},{"id":29,"url":"/static/photos/weddings/IMG_8962.jpg","thumbUrl":"/static/thumbs/weddings/IMG_8962.jpg","style":{"background-image":"url(\"/static/photos/weddings/IMG_8962.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/weddings/IMG_8962.jpg\")"}}]

/***/ }),

/***/ "c27y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__ = __webpack_require__("Zs8U");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ee85ebe_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__ = __webpack_require__("3GKq");
function injectStyle (ssrContext) {
  __webpack_require__("044T")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7ee85ebe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ee85ebe_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ctRS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dXrS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var icons = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'icon',
  props: {
    name: {
      type: String,
      validator: function validator(val) {
        if (val) {
          if (!(val in icons)) {
            console.warn('Invalid prop: prop "name" is referring to an unregistered icon "' + val + '".' + '\nPlease make sure you have imported this icon before using it.');
            return false;
          }
          return true;
        }
        console.warn('Invalid prop: prop "name" is required.');
        return false;
      }
    },
    scale: [Number, String],
    spin: Boolean,
    inverse: Boolean,
    pulse: Boolean,
    flip: {
      validator: function validator(val) {
        return val === 'horizontal' || val === 'vertical';
      }
    },
    label: String
  },
  data: function data() {
    return {
      x: false,
      y: false,
      childrenWidth: 0,
      childrenHeight: 0,
      outerScale: 1
    };
  },

  computed: {
    normalizedScale: function normalizedScale() {
      var scale = this.scale;
      scale = typeof scale === 'undefined' ? 1 : Number(scale);
      if (isNaN(scale) || scale <= 0) {
        console.warn('Invalid prop: prop "scale" should be a number over 0.', this);
        return this.outerScale;
      }
      return scale * this.outerScale;
    },
    klass: function klass() {
      return {
        'fa-icon': true,
        'fa-spin': this.spin,
        'fa-flip-horizontal': this.flip === 'horizontal',
        'fa-flip-vertical': this.flip === 'vertical',
        'fa-inverse': this.inverse,
        'fa-pulse': this.pulse
      };
    },
    icon: function icon() {
      if (this.name) {
        return icons[this.name];
      }
      return null;
    },
    box: function box() {
      if (this.icon) {
        return '0 0 ' + this.icon.width + ' ' + this.icon.height;
      }
      return '0 0 ' + this.width + ' ' + this.height;
    },
    ratio: function ratio() {
      if (!this.icon) {
        return 1;
      }
      var _icon = this.icon,
          width = _icon.width,
          height = _icon.height;

      return Math.max(width, height) / 16;
    },
    width: function width() {
      return this.childrenWidth || this.icon && this.icon.width / this.ratio * this.normalizedScale || 0;
    },
    height: function height() {
      return this.childrenHeight || this.icon && this.icon.height / this.ratio * this.normalizedScale || 0;
    },
    style: function style() {
      if (this.normalizedScale === 1) {
        return false;
      }
      return {
        fontSize: this.normalizedScale + 'em'
      };
    },
    raw: function raw() {
      // generate unique id for each icon's SVG element with ID
      if (!this.icon || !this.icon.raw) {
        return null;
      }
      var raw = this.icon.raw;
      var ids = {};
      raw = raw.replace(/\s(?:xml:)?id=(["']?)([^"')\s]+)\1/g, function (match, quote, id) {
        var uniqueId = getId();
        ids[id] = uniqueId;
        return ' id="' + uniqueId + '"';
      });
      raw = raw.replace(/#(?:([^'")\s]+)|xpointer\(id\((['"]?)([^')]+)\2\)\))/g, function (match, rawId, _, pointerId) {
        var id = rawId || pointerId;
        if (!id || !ids[id]) {
          return match;
        }

        return '#' + ids[id];
      });

      return raw;
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.icon) {
      return;
    }
    this.$children.forEach(function (child) {
      child.outerScale = _this.normalizedScale;
    });
    var width = 0;
    var height = 0;
    this.$children.forEach(function (child) {
      width = Math.max(width, child.width);
      height = Math.max(height, child.height);
    });
    this.childrenWidth = width;
    this.childrenHeight = height;
    this.$children.forEach(function (child) {
      child.x = (width - child.width) / 2;
      child.y = (height - child.height) / 2;
    });
  },
  register: function register(data) {
    for (var name in data) {
      var icon = data[name];

      if (!icon.paths) {
        icon.paths = [];
      }
      if (icon.d) {
        icon.paths.push({ d: icon.d });
      }

      if (!icon.polygons) {
        icon.polygons = [];
      }
      if (icon.points) {
        icon.polygons.push({ points: icon.points });
      }

      icons[name] = icon;
    }
  },

  icons: icons
});

var cursor = 0xd4937;
function getId() {
  return 'fa-' + (cursor++).toString(16);
}

/***/ }),

/***/ "dqBQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:_vm.klass,style:(_vm.style),attrs:{"version":"1.1","role":_vm.label ? 'img' : 'presentation',"aria-label":_vm.label,"x":_vm.x,"y":_vm.y,"width":_vm.width,"height":_vm.height,"viewBox":_vm.box}},[_vm._t("default",[(_vm.icon && _vm.icon.paths)?_vm._l((_vm.icon.paths),function(path,i){return _c('path',_vm._b({key:("path-" + i)},'path',path,false))}):_vm._e(),_vm._v(" "),(_vm.icon && _vm.icon.polygons)?_vm._l((_vm.icon.polygons),function(polygon,i){return _c('polygon',_vm._b({key:("polygon-" + i)},'polygon',polygon,false))}):_vm._e(),_vm._v(" "),(_vm.icon && _vm.icon.raw)?[_c('g',{domProps:{"innerHTML":_vm._s(_vm.raw)}})]:_vm._e()])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fkRi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{staticClass:"logo",attrs:{"src":"/static/logo.png"}})]),_vm._v(" "),_c('div',{staticClass:"main-separator thin"}),_vm._v(" "),_c('b-navbar',{attrs:{"id":"mainNav","toggleable":"lg","sticky":true}},[_c('b-navbar-toggle',{attrs:{"target":"nav_collapse"}}),_vm._v(" "),_c('b-collapse',{attrs:{"is-nav":"","id":"nav_collapse"},model:{value:(_vm.showCollapse),callback:function ($$v) {_vm.showCollapse=$$v},expression:"showCollapse"}},[_c('b-navbar-nav',{attrs:{"justified":""}},[_c('b-nav-item',{on:{"click":function($event){_vm.collapseNav()}}},[_c('router-link',{attrs:{"to":"/portfolio/weddings"}},[_vm._v("Weddings")])],1),_vm._v(" "),_c('b-nav-item',{on:{"click":function($event){_vm.collapseNav()}}},[_c('router-link',{attrs:{"to":"/portfolio/couples"}},[_vm._v("Couples")])],1),_vm._v(" "),_c('b-nav-item',{on:{"click":function($event){_vm.collapseNav()}}},[_c('router-link',{attrs:{"to":"/portfolio/families"}},[_vm._v("Families")])],1),_vm._v(" "),_c('b-nav-item',{on:{"click":function($event){_vm.collapseNav()}}},[_c('router-link',{attrs:{"to":"/investment"}},[_vm._v("Investment")])],1),_vm._v(" "),_c('b-nav-item',{on:{"click":function($event){_vm.collapseNav()}}},[_c('router-link',{attrs:{"to":"/about"}},[_vm._v("Meet Alyson")])],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"main-separator thin"}),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('b-container',{attrs:{"id":"mainFooter"}},[_c('div',{staticClass:"main-separator"}),_vm._v(" "),_c('b-row',[_c('b-col',[_c('div',[_vm._v("Follow Along")]),_vm._v(" "),_c('a',{attrs:{"href":"http://www.facebook.com/pages/Alyson-Sivek-Photography/458803894155150?fref=ts"}},[_c('icon',{attrs:{"name":"brands/facebook","scale":"2"}})],1)]),_vm._v(" "),_c('b-col',[_c('div',[_vm._v("Get In Touch")]),_vm._v(" "),_c('a',{attrs:{"href":"mailto:photographer@alysonsivek.com"}},[_vm._v("photographer@alysonsivek.com")])])],1),_vm._v(" "),_c('b-row',{staticClass:"bottom"},[_c('b-col',[_vm._v("Copyright 2013-2019 Alyson Sivek. All Rights Reserved.")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mGc0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qb6w":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "s6+2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__ = __webpack_require__("Uhku");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e6eb0c88_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__ = __webpack_require__("ROzN");
function injectStyle (ssrContext) {
  __webpack_require__("Nc4y")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e6eb0c88"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e6eb0c88_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uFRC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Slideshow_vue__ = __webpack_require__("act2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05a86e9e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Slideshow_vue__ = __webpack_require__("Q0le");
function injectStyle (ssrContext) {
  __webpack_require__("ctRS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-05a86e9e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Slideshow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05a86e9e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Slideshow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uxbW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"pricing-cards"},[_c('h2',[_vm._v("Pricing")]),_vm._v(" "),_c('b-row',_vm._l((_vm.priceList),function(item){return _c('b-col',{key:item.id,attrs:{"md":"12","lg":"4"}},[_c('div',{staticClass:"card box-shadow"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"my-0 font-weight-normal"},[_vm._v(_vm._s(item.title))])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('small',{staticClass:"mini-top"},[_vm._v(_vm._s(item.mini))]),_vm._v(" "),_c('h1',{staticClass:"card-title pricing-card-title"},[_vm._v(_vm._s(item.price))]),_vm._v(" "),_c('ul',{staticClass:"list-unstyled mt-3 mb-4"},_vm._l((item.features),function(feature){return _c('li',[_vm._v(_vm._s(feature))])})),_vm._v(" "),_c('div',{class:{'force-bottom': item.forceBottom}},[_c('a',{attrs:{"href":item.href}},[_c('button',{staticClass:"btn btn-lg btn-block btn-outline-primary",attrs:{"type":"button"}},[_vm._v("Book Now!")])])])])])])}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wTbr":
/***/ (function(module, exports) {

module.exports = [{"id":0,"url":"/static/photos/main/A.jpg","thumbUrl":"/static/thumbs/main/A.jpg","style":{"background-image":"url(\"/static/photos/main/A.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/main/A.jpg\")"}},{"id":1,"url":"/static/photos/main/B.jpg","thumbUrl":"/static/thumbs/main/B.jpg","style":{"background-image":"url(\"/static/photos/main/B.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/main/B.jpg\")"}},{"id":2,"url":"/static/photos/main/C.jpg","thumbUrl":"/static/thumbs/main/C.jpg","style":{"background-image":"url(\"/static/photos/main/C.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/main/C.jpg\")"}},{"id":3,"url":"/static/photos/main/D.jpg","thumbUrl":"/static/thumbs/main/D.jpg","style":{"background-image":"url(\"/static/photos/main/D.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/main/D.jpg\")"}},{"id":4,"url":"/static/photos/main/E.jpg","thumbUrl":"/static/thumbs/main/E.jpg","style":{"background-image":"url(\"/static/photos/main/E.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/main/E.jpg\")"}},{"id":5,"url":"/static/photos/main/F.jpg","thumbUrl":"/static/thumbs/main/F.jpg","style":{"background-image":"url(\"/static/photos/main/F.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/main/F.jpg\")"}},{"id":6,"url":"/static/photos/main/G.jpg","thumbUrl":"/static/thumbs/main/G.jpg","style":{"background-image":"url(\"/static/photos/main/G.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/main/G.jpg\")"}},{"id":7,"url":"/static/photos/main/H.jpg","thumbUrl":"/static/thumbs/main/H.jpg","style":{"background-image":"url(\"/static/photos/main/H.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/main/H.jpg\")"}},{"id":8,"url":"/static/photos/main/I.jpg","thumbUrl":"/static/thumbs/main/I.jpg","style":{"background-image":"url(\"/static/photos/main/I.jpg\")"},"thumbStyle":{"background-image":"url(\"/static/thumbs/main/I.jpg\")"}}]

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      showCollapse: false
    };
  },

  methods: {
    collapseNav: function collapseNav() {
      if (document.getElementById('nav_collapse').className.indexOf('show') > -1) {
        this.showCollapse = false;
      }
    }
  }
});

/***/ }),

/***/ "yRJc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Portfolio_vue__ = __webpack_require__("B3Kk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_232e1e2d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Portfolio_vue__ = __webpack_require__("QRyc");
function injectStyle (ssrContext) {
  __webpack_require__("mGc0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-232e1e2d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Portfolio_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_232e1e2d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Portfolio_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.5976bcdd832732aba898.js